import gql from 'graphql-tag';
import { ACCOUNT_CONTACT_FRAGMENT } from './fragment';

export const CREATE_ACCOUNT_CONTACT = gql`
  ${ACCOUNT_CONTACT_FRAGMENT}
  mutation CreateAccountContact($input: CreateAccountContactInput!) {
    accountMutation {
      result: createAccountContact(input: $input) {
        success
        error
        entity {
          ...AccountContactFields
        }
      }
    }
  }
`;
